export const customerFields = [{
        name: "name",
        title: "Denominazione",
        render: (record) => record.name
    }, {
        name: "location",
        title: "Comune",
        render: (record) => `${record.city} (${record.province})`
    }, {
        name: "vatNumber",
        title: "Partita IVA",
        render: (record) => record.vatNumber
    }, {
        name: "customer",
        title: "Cliente",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.customerFlag === 1 ? "check" : ""}</i>`
    }, {
        name: "supplier",
        title: "Fornitore",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.supplierFlag === 1 ? "check" : ""}</i>`
    }, {
        name: "carrier",
        title: "Vettore",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.carrierFlag === 1 ? "check" : ""}</i>`
    }, {
        name: "active",
        title: "Attivo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.deleted === 0 ? "check" : "close"}</i>`
    }];
